module.exports = __webpack_public_path__ + "img/ic_food_franchise.290b1894.png";